import React from "react";
import { Typography, List, ListItem, ListItemText } from "@mui/material";
var Review = function (_a) {
    var checkoutToken = _a.checkoutToken;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h6", gutterBottom: true }, "Order Summary"),
        React.createElement(List, { disablePadding: true }, checkoutToken === null || checkoutToken === void 0 ? void 0 :
            checkoutToken.line_items.map(function (product) { return (React.createElement(ListItem, { style: { padding: "10px 0" }, key: product.name },
                React.createElement(ListItemText, { primary: product.name, secondary: "Quantity: ".concat(product.quantity) }),
                React.createElement(Typography, { variant: "body2" }, product.line_total.formatted_with_symbol))); }),
            React.createElement(ListItem, { style: { padding: "10px 0" } },
                React.createElement(ListItemText, { primary: "Total", style: { fontWeight: 700 } }),
                React.createElement(Typography, { variant: "subtitle1", style: { fontWeight: 700 } }, checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.subtotal.formatted_with_symbol)))));
};
export default Review;
